<template>
    <ui-field v-bind="this.$props" v-slot="{ id }">
        <select
            :id="id"
            class="relative block"
            :class="(error ? 'border-red-300 focus:outline-red' : 'border-gray-300 placeholder-gray-400 focus:outline') + ' '+(selectClass?selectClass:'w-full mt-1 border shadow-sm rounded-md sm:text-sm')"
            :name="name"
            :required="required && !readonly"
            :disabled="readonly"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
        >
            <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
                v-text="option.label"
                :selected="isSelected(option.value)"
            ></option>
        </select>
        <input type="hidden" :name="name" :value="value" v-if="readonly"/>
    </ui-field>
</template>

<script>
export default {
    props: {
        value: null,
        selectClass: '',
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,
        required: Boolean,
        readonly: Boolean,
        options: Array,
    },
    methods: {
        isSelected(value) {
            return this.value === value;
        },
    },
}
</script>
